import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  breakpoints,
  fontFamilies,
  fontSizes,
  lineHeights,
  fontWeights,
}: Theme) => ({
  root: {
    padding: '2rem 1.5rem',
    [breakpoints.up('md')]: {
      padding: '4rem 1.5rem',
    },
    [breakpoints.up('xl')]: {
      maxWidth: '42%',
    },
  },
  title: {
    position: 'relative',
    fontFamily: fontFamilies.primary,
    fontWeight: fontWeights.medium,
    fontSize: fontSizes.lg,
    lineHeight: lineHeights.xxl,
    margin: '0 0 12px',
    [breakpoints.up('md')]: {
      fontSize: fontSizes.xxl,
      margin: '0 0 24px',
    },
  },
  backButton: {
    position: 'absolute',
    paddingRight: 5, // to cover gap between title & icon
    top: 2,
    left: -8,
    [breakpoints.up('md')]: {
      top: 1,
      left: -36,
    },
  },
}));
